module.exports = __webpack_public_path__ + "img/business-value.a490baa4.png";